import React from 'react';
import { motion } from 'framer-motion';

/**
 * SplitText — reactbits-style split text animation (reactbits.dev/text-animations/split-text).
 * Splits the text into characters and reveals each with a staggered rise + fade
 * on mount. Accessible: the full string is exposed via aria-label while the
 * per-char spans are aria-hidden.
 */
const SplitText = ({
  text, className, style, delay, duration, stagger,
}) => {
  const chars = Array.from(text || '');
  return (
    <span
      className={className}
      style={{ display: 'inline-flex', flexWrap: 'wrap', ...style }}
      aria-label={text}
    >
      {chars.map((ch, i) => (
        <motion.span
          // eslint-disable-next-line react/no-array-index-key
          key={`${ch}-${i}`}
          aria-hidden="true"
          style={{ display: 'inline-block', whiteSpace: 'pre', willChange: 'transform, opacity' }}
          initial={{ opacity: 0, y: '0.55em' }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: delay + i * stagger, duration, ease: [0.22, 1, 0.36, 1] }}
        >
          {ch === ' ' ? ' ' : ch}
        </motion.span>
      ))}
    </span>
  );
};

SplitText.defaultProps = {
  className: undefined,
  style: undefined,
  delay: 0.05,
  duration: 0.5,
  stagger: 0.035,
};

export default SplitText;
